// ============================================
// HEROSHHI - SHARED LAYOUT FOR SIGN IN, SIGN UP, FORGOT AND RESET PASSWORD
// File: src/pages/auth/AuthLayout.jsx
// One look for all four screens, matching heroshhi.com: navy and gold,
// the form on the left, and on computers the live "every lead has a clock"
// ledger on the right. Styles live here (scoped hs-auth-*) so these screens
// never drift apart again.
// ============================================

import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';

const CSS = `
.hs-auth{--navy:#0E1B33;--raised:#16274A;--raised2:#1B2E56;--line:#26395F;--text:#EAF0F8;--muted:#9AA9C4;--dim:#71809D;--gold:#F2B12A;--coral:#FF7A59;--ok:#7BD3A4;
  min-height:100vh;min-height:100dvh;display:grid;grid-template-columns:minmax(0,1fr) minmax(0,1fr);background:var(--navy);color:var(--text);
  font-family:'Onest',system-ui,-apple-system,'Segoe UI',sans-serif;-webkit-font-smoothing:antialiased}
.hs-auth *{box-sizing:border-box}
.hs-auth a{color:inherit}
.hs-auth :focus-visible{outline:3px solid var(--gold);outline-offset:3px;border-radius:8px}
.hs-auth-main{display:flex;align-items:center;justify-content:center;padding:40px clamp(24px,4vw,56px)}
.hs-auth-logo img{height:34px;width:auto;display:block}
.hs-auth-logo .txt{font-size:26px;font-weight:800;letter-spacing:-.02em;text-decoration:none}
.hs-auth-body{width:100%;display:flex;justify-content:center}
.hs-auth-col .hs-auth-logo{display:inline-block;margin-bottom:36px}
.hs-auth-col{width:100%;max-width:420px}
.hs-auth-col.wide{max-width:480px}
.hs-auth h1{font-size:clamp(28px,3vw,36px);line-height:1.1;letter-spacing:-.02em;font-weight:800;margin:0 0 10px}
.hs-auth-sub{color:var(--muted);font-size:16.5px;line-height:1.55;margin:0 0 28px}
.hs-auth-sub b{color:var(--text);font-weight:600}
.hs-auth-foot{color:var(--muted);font-size:15.5px;margin:28px 0 0}
.hs-auth-foot a{color:var(--text);font-weight:700;text-underline-offset:4px;text-decoration-color:var(--gold)}
.hs-auth-legal{color:var(--dim);font-size:13.5px;line-height:1.5;margin:14px 0 0;text-align:center}
.hs-auth-legal a{color:var(--muted)}
.hs-field{display:block;margin-bottom:18px}
.hs-field-top{display:flex;justify-content:space-between;align-items:baseline;gap:12px;margin-bottom:7px}
.hs-field-label{font-size:15px;font-weight:600}
.hs-field-top a{font-size:14.5px;color:var(--muted);text-underline-offset:4px;text-decoration-color:var(--gold)}
.hs-input{width:100%;min-height:52px;padding:0 16px;border-radius:12px;border:1.5px solid var(--line);background:#0B1629;color:var(--text);font:inherit;font-size:16.5px;transition:border-color .15s}
.hs-input::placeholder{color:var(--dim)}
.hs-input:focus{outline:none;border-color:var(--gold)}
.hs-input.bad{border-color:var(--coral)}
select.hs-input{appearance:none;cursor:pointer;padding-right:42px;background-image:linear-gradient(45deg,transparent 50%,var(--muted) 50%),linear-gradient(135deg,var(--muted) 50%,transparent 50%);background-position:calc(100% - 22px) 50%,calc(100% - 16px) 50%;background-size:6px 6px;background-repeat:no-repeat}
select.hs-input option{background:var(--navy)}
.hs-hint{font-size:13.5px;color:var(--dim);margin:6px 0 0;line-height:1.45}
.hs-hint.bad{color:#FFB39F}
.hs-hint.ok{color:var(--ok)}
.hs-pass{position:relative}
.hs-pass .hs-input{padding-right:52px}
.hs-eye{position:absolute;right:6px;top:50%;transform:translateY(-50%);width:42px;height:42px;display:flex;align-items:center;justify-content:center;border:0;background:none;color:var(--muted);cursor:pointer;border-radius:10px}
.hs-eye:hover{color:var(--text)}
.hs-two{display:grid;grid-template-columns:1fr 1fr;gap:0 16px}
.hs-btn{width:100%;min-height:54px;margin-top:8px;border:0;border-radius:12px;background:var(--gold);color:#10203A;font:inherit;font-size:17px;font-weight:800;cursor:pointer;display:flex;align-items:center;justify-content:center;gap:10px;transition:background .15s}
.hs-btn:hover{background:#FFC24A}
.hs-btn:disabled{opacity:.55;cursor:not-allowed}
.hs-btn.quiet{background:none;border:1.5px solid var(--line);color:var(--text)}
.hs-btn.quiet:hover{border-color:var(--muted);background:none}
.hs-spin{width:18px;height:18px;border-radius:50%;border:2.5px solid rgba(16,32,58,.3);border-top-color:#10203A;animation:hs-spin .8s linear infinite}
@keyframes hs-spin{to{transform:rotate(360deg)}}
.hs-note{display:flex;gap:12px;align-items:flex-start;padding:14px 16px;border-radius:12px;margin:0 0 22px;font-size:15.5px;line-height:1.45;border:1px solid}
.hs-note.bad{background:rgba(255,122,89,.08);border-color:rgba(255,122,89,.35);color:#FFC9BC}
.hs-note.ok{background:rgba(123,211,164,.08);border-color:rgba(123,211,164,.35);color:#C9EEDA}
.hs-note svg{flex:none;margin-top:2px}
.hs-meter{display:flex;gap:5px;margin-top:9px}
.hs-meter i{flex:1;height:4px;border-radius:2px;background:var(--line);transition:background .25s}
.hs-checks{list-style:none;margin:8px 0 0;padding:0;display:grid;gap:4px}
.hs-checks li{font-size:13.5px;color:var(--dim);padding-left:22px;position:relative}
.hs-checks li::before{content:'';position:absolute;left:3px;top:5px;width:10px;height:5px;border-left:2px solid var(--line);border-bottom:2px solid var(--line);transform:rotate(-45deg)}
.hs-checks li.on{color:var(--ok)}
.hs-checks li.on::before{border-color:var(--ok)}
.hs-code{width:100%;min-height:68px;text-align:center;font-size:30px;font-weight:800;letter-spacing:.3em;font-variant-numeric:tabular-nums;padding-left:.3em}
.hs-link-btn{background:none;border:0;padding:0;color:var(--muted);font:inherit;font-size:15px;cursor:pointer;text-decoration:underline;text-underline-offset:4px;text-decoration-color:var(--gold)}
.hs-link-btn:hover{color:var(--text)}
.hs-back{display:inline-block;color:var(--muted);font-size:15px;margin-bottom:22px;text-decoration:none}
.hs-back:hover{color:var(--text)}
.hs-email-chip{display:block;background:var(--raised);border:1px solid var(--line);border-radius:12px;padding:12px 16px;margin:0 0 22px;font-weight:700;word-break:break-all}
/* right panel */
.hs-auth-side{background:var(--raised);border-left:1px solid var(--line);display:flex;flex-direction:column;justify-content:center;padding:48px clamp(28px,4vw,64px)}
.hs-side-line{font-size:clamp(22px,2.2vw,28px);font-weight:800;letter-spacing:-.015em;line-height:1.2;margin:0 0 8px;max-width:20ch}
.hs-side-sub{color:var(--muted);margin:0 0 28px;font-size:16px;max-width:32em}
.hs-ledger{background:var(--navy);border:1px solid var(--line);border-radius:18px;overflow:hidden;max-width:480px}
.hs-ledger-head{display:flex;justify-content:space-between;align-items:baseline;padding:16px 20px;border-bottom:1px solid var(--line)}
.hs-ledger-head b{font-size:15px}
.hs-ledger-head span{font-size:13.5px;color:var(--muted)}
.hs-row{display:grid;grid-template-columns:28px minmax(0,1fr) auto;gap:12px;align-items:center;padding:15px 20px;border-bottom:1px solid var(--line);transition:background-color .6s}
.hs-row:last-of-type{border-bottom:0}
.hs-row b{display:block;font-size:16px}
.hs-row .who span{display:block;font-size:13.5px;color:var(--muted);line-height:1.35}
.hs-clock{text-align:right;font-weight:700;font-size:16px;font-variant-numeric:tabular-nums;white-space:nowrap;transition:color .6s}
.hs-clock small{display:block;font-size:12px;font-weight:500;color:var(--muted)}
.hs-row.silent .hs-clock{color:var(--coral)}
.hs-row.done .hs-clock{color:var(--gold)}
.hs-row.just{background:rgba(242,177,42,.07)}
.hs-ledger-foot{display:flex;gap:20px;padding:12px 20px;background:var(--raised2);font-size:13.5px;color:var(--muted)}
.hs-ledger-foot b{color:var(--text);font-variant-numeric:tabular-nums}
.hs-ledger-foot .c b{color:var(--coral)}
/* quote panel */
.hs-quote{max-width:500px;margin:0}
.hs-quote-mark{display:block;margin:0 0 22px}
.hs-quote p{font-size:clamp(23px,2.3vw,30px);line-height:1.3;letter-spacing:-.012em;font-weight:700;margin:0}
.hs-quote p + p{margin-top:16px;font-size:clamp(17px,1.5vw,19px);line-height:1.55;font-weight:500;letter-spacing:0;color:var(--muted)}
.hs-quote figcaption{display:flex;align-items:center;gap:14px;margin-top:30px;padding-top:24px;border-top:1px solid var(--line)}
.hs-avatar{width:52px;height:52px;border-radius:50%;object-fit:cover;object-position:top;flex:none;border:2px solid var(--gold);background:var(--navy)}
.hs-avatar.ini{display:flex;align-items:center;justify-content:center;background:var(--gold);color:#10203A;font-weight:800;font-size:17px;border:0}
.hs-quote cite{font-style:normal}
.hs-quote cite b{display:block;font-size:16.5px}
.hs-quote cite span{display:block;color:var(--muted);font-size:14.5px}
.hs-quote.big{max-width:580px}
.hs-quote.big .hs-quote-mark{margin-bottom:24px;width:58px;height:43px}
.hs-quote.big blockquote p{font-family:'Fraunces',Georgia,'Times New Roman',serif;font-style:italic;text-wrap:balance}
.hs-quote.big .q1{font-size:clamp(28px,2.6vw,38px);line-height:1.18;font-weight:600;color:#B8C4D9;letter-spacing:-.01em}
.hs-quote.big .q2{margin-top:18px;font-size:clamp(38px,3.9vw,58px);line-height:1.06;font-weight:800;letter-spacing:-.02em;color:var(--text)}
.hs-quote.big .gold{color:var(--gold)}
.hs-quote.big figcaption{border-top:0;padding-top:0;margin-top:32px;gap:14px}
.hs-quote.big .rule{width:36px;height:2px;background:var(--gold);flex:none}
.hs-quote.big cite{font-size:18px;font-weight:700;letter-spacing:.01em}
.hs-quote.big .hs-quote-tie{margin:48px 0 0;padding-top:22px;border-top:1px solid var(--line);color:var(--dim);font-size:15px;line-height:1.55;font-weight:500;letter-spacing:0;max-width:30em}
.hs-changed{list-style:none;margin:30px 0 0;padding:0;max-width:500px;display:grid;gap:12px}
.hs-changed li{display:grid;grid-template-columns:22px minmax(0,1fr);gap:12px;color:var(--muted);font-size:15.5px;line-height:1.45}
.hs-changed li b{color:var(--text);font-weight:600}
@media (max-width:980px){
  .hs-auth{grid-template-columns:1fr}
  .hs-auth-side{display:none}
  .hs-auth-main{align-items:flex-start;padding:24px 22px 32px}
  .hs-auth-col .hs-auth-logo{margin-bottom:30px}
}
@media (max-width:440px){.hs-two{grid-template-columns:1fr}}
@media (prefers-reduced-motion:reduce){.hs-auth *{transition:none!important;animation:none!important}}
`;

// load the website's typeface once, only for these screens
function useAuthStyles() {
  useEffect(() => {
    if (!document.getElementById('hs-auth-font')) {
      const l = document.createElement('link');
      l.id = 'hs-auth-font'; l.rel = 'stylesheet';
      l.href = 'https://fonts.googleapis.com/css2?family=Onest:wght@400;500;600;700;800&family=Fraunces:ital,opsz,wght@1,9..144,600;1,9..144,800&display=swap';
      document.head.appendChild(l);
    }
  }, []);
}

// ---------- icons drawn for these screens ----------
export const EyeIcon = ({ off }) => (
  <svg width="22" height="22" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M2.5 12s3.5-6.5 9.5-6.5 9.5 6.5 9.5 6.5-3.5 6.5-9.5 6.5S2.5 12 2.5 12z" />
    <circle cx="12" cy="12" r="2.8" />
    {off && <path d="M4 20L20 4" />}
  </svg>
);
const AlertIcon = () => (
  <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" aria-hidden="true">
    <circle cx="10" cy="10" r="8" /><path d="M10 6v4.5M10 13.6v.1" />
  </svg>
);
const DoneIcon = () => (
  <svg width="18" height="18" viewBox="0 0 20 20" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="10" cy="10" r="8" /><path d="M6.5 10.3l2.3 2.3 4.7-5" />
  </svg>
);
const Tick = ({ double, color }) => (
  <svg width="28" height="18" viewBox="0 0 30 20" fill="none" stroke={color} strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M3 10.5l4.6 4.6L17 5" />{double && <path d="M11.6 14.6l.6.5L21.6 5" />}
  </svg>
);

// ---------- pieces the four screens share ----------
export const Notice = ({ kind = 'bad', children }) => (
  <div className={`hs-note ${kind}`} role={kind === 'bad' ? 'alert' : 'status'}>
    {kind === 'bad' ? <AlertIcon /> : <DoneIcon />}<div>{children}</div>
  </div>
);

export const Field = ({ id, label, aside, hint, hintKind, children }) => (
  <div className="hs-field">
    <div className="hs-field-top"><label className="hs-field-label" htmlFor={id}>{label}</label>{aside}</div>
    {children}
    {hint && <p className={`hs-hint ${hintKind || ''}`}>{hint}</p>}
  </div>
);

export const PasswordInput = ({ id, name, value, onChange, placeholder, autoComplete, autoFocus, bad, minLength }) => {
  const [show, setShow] = useState(false);
  return (
    <div className="hs-pass">
      <input id={id} name={name} type={show ? 'text' : 'password'} value={value} onChange={onChange}
        className={`hs-input${bad ? ' bad' : ''}`} placeholder={placeholder} autoComplete={autoComplete}
        autoFocus={autoFocus} minLength={minLength} required />
      <button type="button" className="hs-eye" onClick={() => setShow(s => !s)} aria-label={show ? 'Hide password' : 'Show password'} aria-pressed={show}>
        <EyeIcon off={show} />
      </button>
    </div>
  );
};

export const SubmitButton = ({ loading, loadingText, children, disabled }) => (
  <button type="submit" className="hs-btn" disabled={loading || disabled}>
    {loading ? <><span className="hs-spin" aria-hidden="true" />{loadingText}</> : children}
  </button>
);

// password rules, the same everywhere the backend checks them
export const passwordChecks = (p) => [
  { ok: p.length >= 8, text: 'At least 8 characters' },
  { ok: /[A-Za-z]/.test(p), text: 'A letter' },
  { ok: /\d/.test(p), text: 'A number' },
];
export const passwordOk = (p) => passwordChecks(p).every(c => c.ok);

export const PasswordChecklist = ({ password }) => (
  <ul className="hs-checks" aria-label="Password needs">
    {passwordChecks(password).map(c => <li key={c.text} className={c.ok ? 'on' : ''}>{c.text}</li>)}
  </ul>
);

// ---------- the live ledger (computers only) ----------
const fmt = (s) => {
  const h = Math.floor(s / 3600), m = Math.floor((s % 3600) / 60), x = s % 60, p = n => String(n).padStart(2, '0');
  return h ? `${h}h ${p(m)}m ${p(x)}s` : `${m}m ${p(x)}s`;
};
const Ledger = () => {
  const [t, setT] = useState(0);
  const [handled, setHandled] = useState(false);
  useEffect(() => {
    const reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (reduce) return undefined;
    const iv = setInterval(() => setT(v => v + 1), 1000);
    const to = setTimeout(() => setHandled(true), 4200);
    return () => { clearInterval(iv); clearTimeout(to); };
  }, []);
  return (
    <figure className="hs-ledger" style={{ margin: 0 }} aria-label="Example: leads, each with a clock since the last reply">
      <div className="hs-ledger-head"><b>Today's leads</b><span>Skin clinic, Gurugram</span></div>
      <div className="hs-row silent">
        <Tick color="#FF7A59" />
        <div className="who"><b>Aditi S.</b><span>Meta lead ad, owner Meera</span></div>
        <div className="hs-clock">{fmt(172692 + t)}<small>since anyone replied</small></div>
      </div>
      <div className={`hs-row ${handled ? 'done just' : ''}`}>
        <Tick color={handled ? '#F2B12A' : '#71809D'} double={handled} />
        <div className="who"><b>Rahul K.</b><span>{handled ? 'Asked about hair PRP, consultation booked' : 'Asked about hair PRP on WhatsApp'}</span></div>
        <div className="hs-clock">{handled ? <>Replied<small>by Meera, just now</small></> : <>{fmt(1790 + t)}<small>waiting for a reply</small></>}</div>
      </div>
      <div className="hs-row">
        <Tick color="#71809D" />
        <div className="who"><b>Sana M.</b><span>New from the website, owner Kabir</span></div>
        <div className="hs-clock">{fmt(244 + t)}<small>not called yet</small></div>
      </div>
      <div className="hs-ledger-foot"><span><b>{handled ? 13 : 12}</b> handled today</span><span className="c"><b>{handled ? 2 : 3}</b> still waiting</span></div>
    </figure>
  );
};

// ---------- the quote (computers only) ----------
const QuoteMark = () => (
  <svg className="hs-quote-mark" width="46" height="34" viewBox="0 0 46 34" aria-hidden="true">
    <path fill="#F2B12A" d="M0 34V20.5C0 8.9 6.2 1.7 18 0l1.6 5.2C13 7.2 9.9 10.7 9.6 16H18v18H0zm26 0V20.5C26 8.9 32.2 1.7 44 0l1.6 5.2C39 7.2 35.9 10.7 35.6 16H44v18H26z"/>
  </svg>
);
const Quote = () => (
  <figure className="hs-quote big">
    <QuoteMark />
    <blockquote style={{ margin: 0 }}>
      <p className="q1">Our greatest weakness lies in giving up.</p>
      <p className="q2">The most certain way to succeed is to <span className="gold">try just one more time.</span></p>
    </blockquote>
    <figcaption><span className="rule" aria-hidden="true" /><cite>Thomas Edison</cite></figcaption>
    <p className="hs-quote-tie">In sales, one more time is the follow-up call. Heroshhi makes sure it gets made.</p>
  </figure>
);

// ---------- the layout ----------
const Logo = () => {
  const [broken, setBroken] = useState(false);
  return (
    <a className="hs-auth-logo" href="https://heroshhi.com" aria-label="Heroshhi website">
      {broken ? <span className="txt">Heroshhi</span>
        : <img src="/heroshhi-logo-white.png" alt="Heroshhi" onError={() => setBroken(true)} />}
    </a>
  );
};

// panel: 'quote' (Dr. Neha's words, the default) or 'ledger' (the live clocks)
const AuthLayout = ({ children, wide, side = true, panel = 'quote' }) => {
  useAuthStyles();
  return (
    <div className="hs-auth" style={side ? undefined : { gridTemplateColumns: '1fr' }}>
      <style>{CSS}</style>
      <main className="hs-auth-main">
        <div className="hs-auth-body"><div className={`hs-auth-col${wide ? ' wide' : ''}`}><Logo />{children}</div></div>
      </main>
      {side && (
        <aside className="hs-auth-side" aria-label={panel === 'ledger' ? 'What Heroshhi does' : 'What a customer says'}>
          {panel === 'ledger' ? (
            <>
              <p className="hs-side-line">Every lead has a clock. Heroshhi watches it.</p>
              <p className="hs-side-sub">A lead arrives, someone owns it, and the clock starts. When nobody replies, your team knows on their own phone.</p>
              <Ledger />
            </>
          ) : <Quote />}
        </aside>
      )}
    </div>
  );
};

export { Link };
export default AuthLayout;